/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import TweenCSS = alm.util.TweenCSS;
	import Easing = alm.math.Easing;

	export class Opening extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super(jQuery('#sequence .opening'));

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			this.background = view.find('.background');
			this.content = view.find('.content');

			this.date = this.content.find('.date');
			this.title = this.content.find('.title');

			const user = this.content.find('.user');
			this.userName = user.find('.name');
			this.userImage = user.find('.image');

			// set information
			const assetLoader = AssetLoader.getInstance();
			const activity = assetLoader.getActivity();

			const d = DateUtil.createUtcDate(DateUtil.utcToActivityTimeZone(assetLoader.getTrack().getFromDateTime()));
			this.date.text(d.getFullYear() + '.' + (d.getMonth() + 1) + '.' + d.getDate() + ' ' + ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'][d.getDay()]);

			this.title.text(activity.getMapName());
			this.userName.text(activity.getUserName());
			this.userImage.css('background-image', 'url("' + activity.getUserImageUrl() + '")');

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Serial(
				new cmd.Func(():void => {
					view.css({ display: 'block', opacity: 1});

					this.background.css('opacity', 1);
					this.content.css('opacity', 0);
				}),
				new cmd.Wait(useTransition ? 500 : 0), // waiting font download
				TweenCSS.fade(this.content, 0, 1, useTransition ? 1000 : 0, Easing.easeOutSine, "", false, false),
				TweenCSS.fade(this.background, 1, 0.5, useTransition ? 1500 : 0, Easing.easeOutSine, "", false, false),
			);
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return TweenCSS.fadeOut(view, useTransition ? 500 : 0, Easing.easeOutSine, true, false, false);
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private background:JQuery;
		private content:JQuery;
		private date:JQuery;
		private title:JQuery;
		private userName:JQuery;
		private userImage:JQuery;
	}
}
